import React from 'react';
import {Button, ButtonGroup} from 'react-bootstrap';

interface ButtonSelectorFieldProps {
  name: string;
  value: number;
  onChange: (value: number) => void;
  options: Array<{ value: number; label: string }>;
  isRequired?: boolean;
  error?: string;
  touched?: boolean;
  disabled?: boolean;
  size?: 'sm' | 'lg';
  variant?: string;
}

const ButtonSelectorField: React.FC<ButtonSelectorFieldProps> = ({
    name,
    value,
    onChange,
    options,
    isRequired = false,
    error,
    touched,
    disabled = false,
    size,
    variant = 'outline-info'
}) => {
    const hasError = touched && !!error;

    return (
        <div>
            <ButtonGroup className="w-100" size={size}>
                {options.map((option) => (
                    <Button
                        key={option.value}
                        variant={value === option.value ? 'info' : variant}
                        onClick={() => onChange(option.value)}
                        disabled={disabled}
                        className={`flex-fill ${hasError ? 'border-danger' : ''}`}
                        style={{
                            minHeight: '38px',
                            fontSize: '0.75rem',
                            padding: '0.25rem 0.5rem'
                        }}
                    >
                        {option.label}
                    </Button>
                ))}
            </ButtonGroup>

            {hasError && (
                <div className="invalid-feedback d-block mt-1">
                    {error}
                </div>
            )}

            {isRequired && (
                <small className="text-muted">
                    This field is required
                </small>
            )}
        </div>
    );
};

export default ButtonSelectorField;
